class Timesheet {
    id = null;
    placement_id = null;
    date_from = null;
    date_to = null;
    timesheet_status_id = null;
    total_amount = null;
    uploaded_file = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    user_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Timesheet;
